import { Lock } from "lucide-react";
import Odds from "@/components/Odds";

export function PickAnalysis({ pick, locked, onUnlock }) {
  if (!locked) {
    return <p className="text-sm leading-relaxed text-slate-400">{pick.analysis || pick.analysis_preview}</p>;
  }
  return (
    <div>
      <p className="text-sm leading-relaxed text-slate-400">{pick.analysis_preview}</p>
      <div className="paywall-fade mt-2 select-none" aria-hidden="true">
        <p className="text-sm leading-relaxed text-slate-500 blur-[3px]">
          {pick.analysis || "Full matchup breakdown, usage trends and line movement analysis available to VIP members."}
        </p>
      </div>
      <button
        data-testid={`unlock-analysis-btn-${pick.id}`}
        onClick={onUnlock}
        className="mt-3 inline-flex items-center gap-2 rounded-lg border border-[#F59E0B]/50 bg-[#F59E0B]/10 px-4 py-2 font-display text-xs font-bold uppercase tracking-wider text-[#F59E0B] transition-colors hover:bg-[#F59E0B]/20"
      >
        <Lock size={13} /> Unlock Full Analysis
      </button>
    </div>
  );
}

export function PickMeta({ pick }) {
  const cells = [
    ["Odds", <Odds key="odds" value={pick.odds} />],
    ["Stake", `${pick.units}U`],
    ["Posted", pick.postedLabel],
  ];
  return (
    <div className="mt-4 grid grid-cols-3 gap-3 border-y border-[#1E2738] py-3 font-mono text-xs">
      {cells.map(([label, value]) => (
        <div key={label}>
          <p className="text-slate-500 uppercase tracking-wider text-[10px]">{label}</p>
          <p className="mt-0.5 text-sm font-bold text-white">{value}</p>
        </div>
      ))}
    </div>
  );
}
